export default {"src":"/_next/static/media/mfo-glfh-branch.65cd5eb4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};